(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const journey = root.querySelector('[data-journey]');
    if (journey) {
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const toggle = journey.querySelector('[data-journey-toggle]');
      const controls = journey.querySelector('[data-journey-controls]');
      let inView = false;
      let paused = false;
      const syncJourney = () => {
        const enabled = !motion.matches;
        journey.classList.toggle('is-journey-enabled', enabled);
        journey.classList.toggle('is-journey-suspended', !inView || paused || document.hidden);
        journey.dataset.journeyState = !enabled ? 'static' : (!inView || paused || document.hidden ? 'paused' : 'playing');
        if (controls) controls.hidden = !enabled;
        if (toggle) {
          toggle.setAttribute('aria-pressed', String(paused));
          toggle.textContent = paused ? toggle.dataset.resume : toggle.dataset.pause;
        }
      };
      if ('IntersectionObserver' in window) {
        const journeyObserver = new IntersectionObserver((entries) => {
          inView = entries.some((entry) => entry.isIntersecting);
          syncJourney();
        }, { threshold: 0.05 });
        journeyObserver.observe(journey);
      } else { inView = true; }
      toggle?.addEventListener('click', () => { paused = !paused; syncJourney(); });
      motion.addEventListener?.('change', syncJourney);
      document.addEventListener('visibilitychange', syncJourney);
      syncJourney();
    }
    const form = root.querySelector('form.chpro__form');
    const interests = Array.from(root.querySelectorAll('[data-interest]'));
    const network = root.querySelector('[data-interest="network"]');
    const details = root.querySelector('[data-network-fields]');
    const jsInterests = root.querySelector('[data-js-interests]');
    if (jsInterests) jsInterests.hidden = false;
    const storageKey = 'crownhair:professional:pending';
    const canMeasure = () => {
      try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
      catch (_) { return false; }
    };
    const publish = (event, data = {}) => {
      if (!canMeasure() || typeof window.Shopify?.analytics?.publish !== 'function') return;
      try { Promise.resolve(window.Shopify.analytics.publish(event, { source: 'professional_page', ...data })).catch(() => {}); }
      catch (_) {}
    };
    const selection = () => interests.filter((field) => field.checked).map((field) => field.dataset.interest);
    const update = () => {
      if (interests[0]) interests[0].setCustomValidity(selection().length ? '' : root.dataset.interestError);
      if (details && network) {
        details.hidden = !network.checked;
        details.disabled = !network.checked;
      }
    };
    interests.forEach((field) => field.addEventListener('change', update));
    update();
    root.querySelectorAll('[data-intent]').forEach((link) => {
      link.addEventListener('click', () => {
        const target = root.querySelector(`[data-interest="${link.dataset.intent}"]`);
        if (target) window.requestAnimationFrame(() => target.focus({ preventScroll: true }));
      });
    });
    root.querySelectorAll('[data-wa]').forEach((link) => link.addEventListener('click', () => publish('crownhair:professional_whatsapp_open', { interest: link.dataset.wa })));
    if (form && interests.length) {
      form.addEventListener('submit', (event) => {
        update();
        if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
        try { sessionStorage.removeItem(storageKey); } catch (_) {}
        if (!canMeasure()) return;
        try { sessionStorage.setItem(storageKey, JSON.stringify({ interests: selection(), time: Date.now() })); } catch (_) {}
      });
    }
    if (root.querySelector('[data-success]')) {
      try {
        const attempt = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        sessionStorage.removeItem(storageKey);
        if (attempt && Date.now() - attempt.time < 1800000 && Date.now() >= attempt.time && Array.isArray(attempt.interests)) {
          if (attempt.interests.includes('supply')) publish('crownhair:professional_supply_received');
          if (attempt.interests.includes('network')) publish('crownhair:professional_network_received');
        }
      } catch (_) {}
      root.querySelector('[data-success]').focus({ preventScroll: true });
    }
    if (root.querySelector('[data-form-errors]')) {
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      root.querySelector('[data-form-errors]').focus({ preventScroll: true });
    }
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('chpro__seen'); observer.unobserve(entry.target); }
      }), { threshold: 0.04 });
      root.querySelectorAll('.chpro__section, .chpro__proposal').forEach((section) => observer.observe(section));
    }
  };
  const start = (scope) => {
    if (scope.matches?.('[data-chpro]')) init(scope);
    scope.querySelectorAll('[data-chpro]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
